import Logger from "../services/Logger";
import Transport from "../transport/server";
import { ServerEndpoints } from "../types/types";
const SHOW_LOGS = true;
const TAG = 'core/activityVisits';
export const captureActivityVisit = async (activity, sessionId, deviceId, raftType, robotId) => {
    Logger.info(SHOW_LOGS, TAG, `Capturing activity visit of type: ${activity}`);
    try {
        const data = { activity, sessionId, deviceId, raftType, robotId };
        const response = await Transport.post(ServerEndpoints.ACTIVITY_VISIT, data);
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Error response from server: ${errorText}`);
        }
        Logger.info(SHOW_LOGS, TAG, 'Activity visit tracked successfully');
        return true;
    }
    catch (error) {
        Logger.error(SHOW_LOGS, TAG, 'Failed to track activity visit', error);
        return false;
    }
};
